export default "__VITE_ASSET__4961b2af__"